export const global = {
  fontFamily: "Avenir, sans-serif"
};
